import {
  GET_LIST_CFOP_SUCCESS,
  GET_LIST_CFOP_FAILURE,
  PUT_CFOP_SUCCESS,
  CFOP_CLEAN,
  PUT_CFOP_FAILURE,
} from "../../../../constants/actionTypes";
const INITIAL_STATE = {
  list: [],
  data: {},
  status: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_LIST_CFOP_SUCCESS:
      return {
        ...state,
        list: action.payload.Items,
        paging: action.payload.Paging,
      };
    case GET_LIST_CFOP_FAILURE:
      return {
        ...state,
        status: 400,
      };
    case PUT_CFOP_SUCCESS:
      return {
        ...state,
        status: action.payload?.StatusCode,
      };
    case PUT_CFOP_FAILURE:
      return {
        ...state,
        status: action.payload?.StatusCode,
      };
    case CFOP_CLEAN:
      return {
        ...state,
        status: null,
      };
    default:
      return state;
  }
};
